const i18n = {
  'en-US': {
    'menu.welcome': 'Welcome',
    'menu.dashboard': 'Dashboard',
    'menu.list': 'List',
    'menu.result': 'Result',
    'menu.exception': 'Exception',
    'menu.form': 'Form',
    'menu.profile': 'Profile',
    'menu.visualization': 'Data Visualization',
    'menu.user': 'User Center',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.profile.basic': 'Basic Profile',
    'menu.list.cardList': 'Card List',
    'menu.visualization.dataAnalysis': 'Analysis',
    'menu.result.error': 'Error',
    'menu.form.group': 'Group Form',
    'menu.dashboard.monitor': 'Real-time Monitor',
    'menu.visualization.multiDimensionDataAnalysis': 'Multi-D Analysis',
    'menu.list.searchTable': 'Search Table',
    'menu.form.step': 'Step Form',
    'menu.result.success': 'Success',
    'menu.user.info': 'User Info',
    'menu.user.setting': 'User Setting',
    'menu.user.switchRoles': 'Switch Roles',
    'menu.user.role.admin': 'Admin',
    'menu.user.role.user': 'General User',
    'menu.dashboard.workplace': 'Workplace',
    'menu.system': 'System',
    'menu.system.menus': 'Menu Management',
    'menu.system.users': 'User Management',
    'menu.system.roles': 'Role Management',
    'menu.system.modules': 'Module Management',
    'menu.system.permissions': 'Permission Management',
    'menu.companies': 'Companies',
    'menu.companies.list': 'Company List',
    'menu.companies.department': 'Department Management',
    'menu.companies.tax_codes': 'Tax Codes',
    'menu.suppliers': 'Supplier',
    'menu.suppliers.list': 'Supplier List',
    'menu.suppliers.purchase_invoice': 'Purchase Invoice',
    'menu.suppliers.supplier_payment': 'Supplier Payment',
    'menu.suppliers.debit_note': 'Debit Note',
    'menu.suppliers.credit_note': 'Credit Note',
    'menu.customers': 'Customer',
    'menu.customers.list': 'Customer List',
    'menu.customers.sales_invoice': 'Sales Invoice',
    'menu.customers.debit_note': 'Debit Note',
    'menu.customers.credit_note': 'Credit Note',
    'menu.customers.customer_receipt': 'Customer Receipt',
    'menu.knock_off': 'Knock Off',
    'menu.general_ledger': 'General Ledger',
    'menu.general_ledger.accounts': 'Chart of Account',
    'menu.general_ledger.journal_entry': 'Journal Entry',
    'menu.general_ledger.journal_entry.create': 'Create Journal Entry',
    'menu.general_ledger.cashbook_entry': 'Cash Book Entry',
    'menu.general_ledger.bank_reconciliation': 'Bank Reconciliation',
    'menu.general_ledger.bank_reconciliation_report': 'Bank Reconciliation Report',
    'menu.general_ledger.chart_of_account': 'Chart of Account',
    'menu.general_ledger.financial_year': 'Financial Year',
    'menu.general_ledger.opening_balance': 'Opening Balance',
    'menu.general_ledger.stock_value': 'Stock Value',
    'menu.reports': 'Reports',
    'menu.reports.general_ledger': 'General Ledger',
    'menu.reports.trial_balance': 'Trial Balance Report',
    'menu.reports.profit_loss': 'Profit and Loss Statement',
    'menu.reports.balance_sheet': 'Balance Sheet Statement',
    'menu.reports.balance_sheet_tree': 'Balance Sheet (Tree View)',
    'navbar.logout': 'Logout',
    'navbar.logout.confirm.title': 'Logout Confirm',
    'navbar.logout.confirm.content': 'Are you sure you want to logout?',
    'settings.title': 'Settings',
    'settings.themeColor': 'Theme Color',
    'settings.content': 'Content Setting',
    'settings.navbar': 'Navbar',
    'settings.menuWidth': 'Menu Width (px)',
    'settings.navbar.theme.toLight': 'Switch to Light',
    'settings.navbar.theme.toDark': 'Switch to Dark',
    'settings.menu': 'Menu',
    'settings.footer': 'Footer',
    'settings.otherSettings': 'Other Settings',
    'settings.colorWeek': 'Color Week',
    'settings.alertContent': 'After the configuration is only temporarily effective, if you want to really affect the project, click the "Copy Settings" button below and replace the configuration in settings.json.',
    'settings.copySettings': 'Copy Settings',
    'settings.copySettings.message': 'Copy succeeded, please paste to file src/settings.json.',
    'settings.close': 'Close',
    'settings.color.tooltip': '10 gradient colors generated according to the theme color',
    'message.tab.title.message': 'Message',
    'message.tab.title.notice': 'Notice',
    'message.tab.title.todo': 'ToDo',
    'message.allRead': 'All Read',
    'message.seeMore': 'SeeMore',
    'message.empty': 'Empty',
    'message.empty.tips': 'No Content',
    'message.lang.tips': 'Language switch to ',
    'navbar.search.placeholder': 'Please search',
    'navbar.switchCompany.success': 'Company switched successfully',
    'navbar.switchCompany.fail': 'Failed to switch company',
    // API相关本地化消息
    'api.requestError': 'Request error, please try again later',
    'api.loginExpired': 'Login expired, please log in again',
    'api.networkError': 'Network error, please try again later',
    'api.csrfInitFailed': 'Failed to initialize CSRF cookie',
    // Tab context menu
    'tab.context.closeCurrent': 'Close Current',
    'tab.context.closeOther': 'Close Others',
    'tab.context.closeAll': 'Close All',
    'tab.context.refresh': 'Refresh',
    'tab.context.refreshAll': 'Refresh All',
    'tab.context.pin': 'Pin Tab',
    'tab.context.unpin': 'Unpin Tab'
  },
  'zh-CN': {
    'menu.dashboard': '仪表盘',
    'menu.list': '列表页',
    'menu.result': '结果页',
    'menu.exception': '异常页',
    'menu.form': '表单页',
    'menu.profile': '详情页',
    'menu.visualization': '数据可视化',
    'menu.user': '个人中心',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.profile.basic': '基础详情页',
    'menu.list.cardList': '卡片列表',
    'menu.visualization.dataAnalysis': '分析页',
    'menu.result.error': '失败页',
    'menu.form.group': '分组表单',
    'menu.dashboard.monitor': '实时监控',
    'menu.visualization.multiDimensionDataAnalysis': '多维数据分析',
    'menu.list.searchTable': '查询表格',
    'menu.form.step': '分步表单',
    'menu.result.success': '成功页',
    'menu.user.info': '用户信息',
    'menu.user.setting': '用户设置',
    'menu.user.switchRoles': '切换角色',
    'menu.user.role.admin': '管理员',
    'menu.user.role.user': '普通用户',
    'menu.dashboard.workplace': '工作台',
    'menu.system': '系统设置',
    'menu.system.menus': '菜单管理',
    'menu.system.users': '用户管理',
    'menu.system.roles': '角色管理',
    'menu.system.modules': '模块管理',
    'menu.system.permissions': '权限管理',
    'menu.companies': '公司',
    'menu.companies.list': '公司列表',
    'menu.companies.department': '部门管理',
    'menu.companies.tax_codes': '税号管理',
    'menu.suppliers': '供应商',
    'menu.suppliers.list': '供应商列表',
    'menu.suppliers.purchase_invoice': '采购发票',
    'menu.suppliers.supplier_payment': '供应商付款',
    'menu.suppliers.debit_note': '借项通知单',
    'menu.suppliers.credit_note': '贷项通知单',
    'menu.customers': '客户',
    'menu.customers.list': '客户列表',
    'menu.customers.sales_invoice': '销售发票',
    'menu.customers.debit_note': '借项通知单',
    'menu.customers.credit_note': '贷项通知单',
    'menu.customers.customer_receipt': '客户收据',
    'menu.knock_off': '抵销',
    'menu.general_ledger': '总账',
    'menu.general_ledger.accounts': '会计科目表',
    'menu.general_ledger.journal_entry': '日记账分录',
    'menu.general_ledger.journal_entry.create': '创建日记账分录',
    'menu.general_ledger.cashbook_entry': '现金账簿分录',
    'menu.general_ledger.bank_reconciliation': '银行对账',
    'menu.general_ledger.bank_reconciliation_report': '银行对账报告',
    'menu.general_ledger.chart_of_account': '会计科目表',
    'menu.general_ledger.financial_year': '财务年度',
    'menu.general_ledger.opening_balance': '期初余额',
    'menu.general_ledger.stock_value': '库存价值',
    'menu.reports': '报表',
    'menu.reports.general_ledger': '总账报表',
    'menu.reports.trial_balance': '试算平衡表',
    'menu.reports.profit_loss': '损益表',
    'menu.reports.balance_sheet': '资产负债表',
    'menu.reports.balance_sheet_tree': '资产负债表（树形）',
    'navbar.logout': '退出登录',
    'navbar.logout.confirm.title': '确认注销',
    'navbar.logout.confirm.content': '确定要注销当前账户吗？',
    'settings.title': '页面配置',
    'settings.themeColor': '主题色',
    'settings.content': '内容区域',
    'settings.navbar': '导航栏',
    'settings.menuWidth': '菜单宽度 (px)',
    'settings.navbar.theme.toLight': '亮色模式',
    'settings.navbar.theme.toDark': '暗黑模式',
    'settings.menu': '菜单栏',
    'settings.footer': '底部',
    'settings.otherSettings': '其他设置',
    'settings.colorWeek': '色弱模式',
    'settings.alertContent': '配置之后仅是临时生效，要想真正作用于项目，点击下方的 "复制配置" 按钮，将配置替换到 settings.json 中即可。',
    'settings.copySettings': '复制配置',
    'settings.copySettings.message': '复制成功，请粘贴到 src/settings.json 文件中',
    'settings.close': '关闭',
    'settings.color.tooltip': '根据主题颜色生成的 10 个梯度色（将配置复制到项目中，主题色才能对亮色 / 暗黑模式同时生效）',
    'message.tab.title.message': '消息',
    'message.tab.title.notice': '通知',
    'message.tab.title.todo': '待办',
    'message.allRead': '全部已读',
    'message.seeMore': '查看更多',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'message.lang.tips': '语言切换至 ',
    'navbar.search.placeholder': '输入内容查询',
    'navbar.switchCompany.success': '公司切换成功',
    'navbar.switchCompany.fail': '公司切换失败',
    // API相关本地化消息
    'api.requestError': '请求出错，请稍后重试',
    'api.loginExpired': '登录过期，请重新登录',
    'api.networkError': '网络错误，请稍后重试',
    'api.csrfInitFailed': '初始化CSRF cookie失败',
    // Tab 右键菜单
    'tab.context.closeCurrent': '关闭当前',
    'tab.context.closeOther': '关闭其他',
    'tab.context.closeAll': '关闭全部',
    'tab.context.refresh': '刷新',
    'tab.context.refreshAll': '刷新所有',
    'tab.context.pin': '固定标签',
    'tab.context.unpin': '取消固定'
  }
};
export default i18n;